import React from 'react';

const VIP_TIERS = {
  bronze:   { label: 'Bronze',   icon: '🥉', color: '#cd7f32', bg: 'rgba(205,127,50,0.15)',  min: 0     },
  silver:   { label: 'Silver',   icon: '🥈', color: '#c0c0c0', bg: 'rgba(192,192,192,0.15)', min: 100   },
  gold:     { label: 'Gold',     icon: '🥇', color: '#f5c400', bg: 'rgba(245,196,0,0.15)',   min: 500   },
  diamond:  { label: 'Diamond',  icon: '💎', color: '#a0d8ef', bg: 'rgba(160,216,239,0.15)', min: 2000  },
  platinum: { label: 'Platinum', icon: '👑', color: '#e8e8e8', bg: 'rgba(232,232,232,0.15)', min: 10000 },
};

export function VipBadge({ tier = 'bronze', size = 'sm' }) {
  const t = VIP_TIERS[tier] || VIP_TIERS.bronze;
  const sizes = { sm: { fontSize: 11, padding: '2px 8px', iconSize: 12 }, md: { fontSize: 13, padding: '4px 12px', iconSize: 16 }, lg: { fontSize: 16, padding: '6px 16px', iconSize: 22 } };
  const s = sizes[size] || sizes.sm;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: s.padding, borderRadius: 20, background: t.bg, border: `1px solid ${t.color}`, fontSize: s.fontSize, fontWeight: 700, color: t.color, letterSpacing: '0.05em' }}>
      <span style={{ fontSize: s.iconSize }}>{t.icon}</span>
      {t.label}
    </span>
  );
}

export function VipProgress({ totalDeposited = 0 }) {
  const tiers = Object.entries(VIP_TIERS);
  const currentIdx = tiers.reduce((acc, [key, t], i) => totalDeposited >= t.min ? i : acc, 0);
  const current = tiers[currentIdx];
  const next = tiers[currentIdx + 1];
  const progress = next ? Math.min(100, ((totalDeposited - current[1].min) / (next[1].min - current[1].min)) * 100) : 100;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <VipBadge tier={current[0]} size="md" />
        {next && <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Next: <span style={{ color: next[1].color }}>{next[1].icon} {next[1].label}</span> at ${next[1].min.toLocaleString()}</span>}
      </div>
      <div style={{ height: 8, background: 'var(--border)', borderRadius: 4, overflow: 'hidden' }}>
        <div style={{ width: `${progress}%`, height: '100%', background: `linear-gradient(90deg, ${current[1].color}, ${next?.[1]?.color || current[1].color})`, borderRadius: 4, transition: 'width 0.5s' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6, fontSize: 11, color: 'var(--text-muted)' }}>
        <span>Total Deposited: <strong style={{ color: 'var(--text-primary)' }}>${totalDeposited.toLocaleString()}</strong></span>
        {next && <span>Need: ${Math.max(0, next[1].min - totalDeposited).toLocaleString()} more</span>}
        {!next && <span style={{ color: '#f5c400', fontWeight: 700 }}>MAX TIER 👑</span>}
      </div>
      {/* All tiers */}
      <div style={{ display: 'flex', gap: 8, marginTop: 14, flexWrap: 'wrap' }}>
        {tiers.map(([key, t]) => (
          <div key={key} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11, opacity: totalDeposited >= t.min ? 1 : 0.35 }}>
            <span style={{ fontSize: 14 }}>{t.icon}</span>
            <span style={{ color: totalDeposited >= t.min ? t.color : 'var(--text-muted)', fontWeight: totalDeposited >= t.min ? 700 : 400 }}>{t.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export { VIP_TIERS };
export default VipBadge;
